
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Eightseatercabonrent() {



    const cardData =
    {
        keyword: '8 Seater Cab on Rent in Pune',
        heading: 'Platinum24 Cabs: 8 Seater Cab on Rent in Pune',
        headingDescription: ' Platinum24 Cabs offers spacious 8 Seater Cab on Rent in Pune, perfect for small groups, family trips, airport transfers, and outstation journeys. Our well-maintained AC cabs provide ample seating, comfortable legroom, and sufficient luggage space, making them ideal for long and short-distance travel. With professional chauffeurs, timely pickups, and transparent fares, we ensure safe and hassle-free travel for groups who prefer to ride together. Whether it’s a weekend getaway, a corporate outing, or a pilgrimage tour, Platinum24 Cabs guarantees affordable, reliable, and convenient 8-seater cab rental services in Pune.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort palace. Once the seat of the Maratha Empire, its majestic gates, fountains, and sprawling gardens narrate stories of valor and legacy. Though partially destroyed by fire in 1828, its ruins still captivate tourists. The evening light-and-sound show brings alive Bajirao and Mastani’s era. A must-visit for history lovers, it is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, constructed in 1892, is a historic monument tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. The palace now houses a museum showcasing Gandhi’s personal belongings and rare photographs. Its Italian arches, sprawling lawns, and tranquil vibe make it a top tourist attraction. It is Pune’s historic gem of inspiration and peace."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, 25 km from Pune, is famous for the 1670 battle fought by Tanaji Malusare for Chhatrapati Shivaji Maharaj. Perched on a hill, it offers trekking trails and panoramic Sahyadri views. Visitors explore bastions, memorials, and temples that echo Maratha bravery. Monsoon enhances its beauty with misty clouds and waterfalls. Locals serve rustic pithla-bhakri at the fort. Sinhagad is Pune’s perfect mix of adventure, history, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The grand idol is adorned with gold and jewels, attracting thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of festivities. It is also known for charitable and cultural activities. The spiritual energy here is unmatched. Dagdusheth Temple is Pune’s divine cultural and spiritual heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is dedicated to Lord Shiva. Its rock-cut sanctum, stone pillars, and Nandi mandapa reflect ancient Indian craftsmanship. Despite being in the heart of the city, it offers peace and a spiritual retreat. Evening aartis create a mystical aura. History lovers admire its timeless carvings. Pataleshwar is Pune’s hidden gem of spirituality and heritage."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include ornaments, musical instruments, sculptures, and antiques from daily life. Its highlight is the recreated Mastani Mahal. Students and history lovers find it highly educational and engaging. The museum preserves traditions from across India’s regions. It is Pune’s cultural treasure chest of art and heritage."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The Parvati Temple atop the hill is dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the temple, blending devotion with adventure. The site also houses a small museum and shrines. Sunsets and sunrises from here are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub of wellness and spirituality. Spread across lush gardens, it offers meditation, yoga, and self-discovery programs. Japanese Zen gardens, swimming pools, and meditation halls enhance the experience. It attracts seekers from across the world. Visitors leave with peace and rejuvenation. Osho Ashram is Pune’s international center of mindfulness."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, modeled after Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and beautifully manicured lawns. Families enjoy walks, photography, and picnics here. Seasonal flowers and greenery make it picturesque year-round. It symbolizes Indo-Japanese friendship. Pu La Deshpande Garden is Pune’s green paradise of peace and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam on the Mutha River is a popular weekend retreat near Pune. It supplies water to the city while offering scenic landscapes of hills and waters. In monsoon, the dam overflows spectacularly, drawing crowds. Vendors serve hot corn and tea, adding to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural escape."
  }
],



    "services": [
    {
      "name": "8-Seater Cab Rental Pune",
      "description": "Experience spacious and comfortable travel with our 8-Seater Cab Rental service in Pune. Perfect for families, group trips, and corporate outings, our cabs offer ample room to relax during your journey. Whether it's a city tour, airport transfer, or outstation travel, our well-maintained vehicles ensure safety, cleanliness, and convenience for all passengers. Book now for hassle-free group travel with professional drivers and transparent pricing."
    },
    {
      "name": "Pune 8-Seater Taxi Hire",
      "description": "Hire an 8-Seater Taxi in Pune tailored to meet your group’s transportation needs. Our service caters to weddings, corporate events, sightseeing tours, and more. Enjoy the luxury of traveling together without compromising on comfort or style. Our drivers are trained for smooth driving, punctual pickups, and courteous service, making every trip a pleasant experience."
    },
    {
      "name": "8-Seater Car on Rent Pune",
      "description": "Rent an 8-Seater car in Pune for your special occasions or everyday group travel. Our vehicles include spacious SUVs and tempo travellers equipped with modern amenities. With flexible rental plans ranging from hourly to daily and long-term options, you can customize your travel itinerary while enjoying competitive rates and excellent customer support."
    },
    {
      "name": "Pune 8-Seater Cab with Driver",
      "description": "Book an 8-Seater Cab with Driver in Pune and travel stress-free. Our professional chauffeurs are well-versed with Pune’s routes, traffic conditions, and key destinations. Relax and enjoy your journey while we handle the driving, ensuring timely arrivals and comfortable rides for your entire group."
    },
    {
      "name": "8-Seater Tempo Traveller Pune",
      "description": "For larger groups seeking premium travel, our 8-Seater Tempo Traveller service in Pune offers spacious interiors, ample luggage space, and excellent ride quality. Ideal for long-distance trips, family outings, and group excursions, our tempo travellers come with all safety features and are driven by experienced drivers to guarantee a smooth trip."
    },
    {
      "name": "Affordable 8-Seater Cab Pune",
      "description": "Looking for budget-friendly group travel options? Our Affordable 8-Seater Cab service in Pune offers competitive pricing without compromising on quality. Enjoy comfortable seating, timely service, and transparent billing tailored for families, friends, and corporate groups planning outings within or outside Pune."
    },
    {
      "name": "8-Seater Taxi Booking Pune",
      "description": "Booking an 8-Seater Taxi in Pune has never been easier. Use our intuitive online platform or mobile app to reserve your group cab instantly. Choose your preferred pickup time, destination, and vehicle type with real-time availability updates. Our customer support team is always ready to assist you for any special requests or custom plans."
    },
    {
      "name": "Pune 8-Seater Family Cab",
      "description": "Travel comfortably with your entire family using our Pune 8-Seater Family Cab service. Equipped to handle family trips, outings, and special occasions, these cabs provide ample space for children and elders alike. Safety, convenience, and personalized service are our priorities to make your family travel memorable and hassle-free."
    },
    {
      "name": "8-Seater Outstation Cab Pune",
      "description": "Explore destinations beyond Pune with our reliable 8-Seater Outstation Cab service. Whether it's a weekend getaway, pilgrimage trip, or corporate retreat, our vehicles are ideal for long-distance travel offering comfort, air-conditioning, and safety. Our experienced drivers ensure smooth journeys while you focus on enjoying your trip."
    },
    {
      "name": "8-Seater Cab Packages Pune",
      "description": "Choose from our flexible 8-Seater Cab Packages in Pune designed for hourly, daily, and multi-day use. Whether you need a cab for local sightseeing, airport transfers, or outstation travel, our packages offer great value, including driver allowances, tolls, and taxes. Customize your travel plans with us for a seamless group transport experience."
    },
    {
      "name": "Pune 8-Seater Airport Taxi",
      "description": "Make your airport transfers stress-free with our Pune 8-Seater Airport Taxi service. We provide timely pickups and drop-offs to and from Pune Airport with ample space for luggage and passengers. Our drivers track your flight timings to avoid delays, ensuring you reach your destination comfortably and on time."
    },
    {
      "name": "8-Seater Group Travel Cab Pune",
      "description": "Planning group travel in Pune? Our 8-Seater Group Travel Cab service is perfect for office outings, family trips, and friends’ excursions. Enjoy coordinated travel with spacious seating, onboard amenities, and flexible pick-up/drop points. Experience convenience and togetherness while exploring Pune and nearby regions."
    },
    {
      "name": "Pune 8-Seater Cab Deals",
      "description": "Avail special offers and discounts on our Pune 8-Seater Cab services. Whether booking for festivals, weddings, or corporate events, our deals provide affordable options with added benefits like free waiting time, complimentary toll charges, and no hidden fees. Book now and save more on your group travel."
    },
    {
      "name": "8-Seater Cab for Corporate Pune",
      "description": "Enhance your corporate travel with our dedicated 8-Seater Cab for Corporate service in Pune. Perfect for team outings, client transfers, and business meetings, we ensure punctuality, professional drivers, and premium vehicles. Customized billing and flexible scheduling make corporate transport efficient and hassle-free."
    },
    {
      "name": "8-Seater Cab Rental Service Pune",
      "description": "Our comprehensive 8-Seater Cab Rental Service in Pune caters to all your group travel needs with a fleet of well-maintained vehicles, professional drivers, and 24/7 customer support. We prioritize your comfort, safety, and timely service to deliver a reliable travel experience for any occasion."
    }
  ],
  "tableData": [
    ["8-Seater Cab Rental Pune", "Pune 8-Seater Taxi Hire"],
    ["8-Seater Car on Rent Pune", "Pune 8-Seater Cab with Driver"],
    ["8-Seater Tempo Traveller Pune", "Affordable 8-Seater Cab Pune"],
    ["8-Seater Taxi Booking Pune", "Pune 8-Seater Family Cab"],
    ["8-Seater Outstation Cab Pune", "8-Seater Cab Packages Pune"],
    ["Pune 8-Seater Airport Taxi", "8-Seater Group Travel Cab Pune"],
    ["Pune 8-Seater Cab Deals", "8-Seater Cab for Corporate Pune"],
    ["8-Seater Cab Rental Service Pune", "—"]
  ],


           "whychoose": [
    {
      "WhyChooseheading": "Spacious 8 Seater Cab on Rent in Pune",
      "WhyChoosedescription": "Platinum24 Cabs offers comfortable and roomy 8 seater cabs perfect for group travel in Pune."
    },
    {
      "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
      "WhyChoosedescription": "Travel safely in our clean, air-conditioned 8 seater cabs maintained for your comfort."
    },
    {
      "WhyChooseheading": "Experienced Drivers Familiar with Pune Routes",
      "WhyChoosedescription": "Our professional drivers ensure a smooth and timely journey around Pune and nearby areas."
    },
    {
      "WhyChooseheading": "Flexible Rental Packages for Local and Outstation Trips",
      "WhyChoosedescription": "Choose from hourly, daily, or customized rental plans to suit your travel needs."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
      "WhyChoosedescription": "Enjoy upfront pricing covering fuel, tolls, and driver allowances for stress-free booking."
    },
    {
      "WhyChooseheading": "Easy Online Booking with 24/7 Support",
      "WhyChoosedescription": "Book your 8 seater cab anytime with assistance from our dedicated customer service team."
    },
    {
      "WhyChooseheading": "Ideal for Family Trips, Corporate Travel, and Group Outings",
      "WhyChoosedescription": "Our 8 seater cabs are perfect for comfortable group travel within and outside Pune."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options Available",
      "WhyChoosedescription": "Select from various 8 seater models like Innova, Tempo Traveller, and more based on your preference."
    }
  ]































    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer 8 seater cab rentals in Pune?',
        answer: 'Yes, Platinum24 Cabs provides 8 seater cab rentals in Pune, perfect for group travel and family outings.',
    },
    {
        question: 'How can I book an 8 seater cab on rent in Pune?',
        answer: 'You can book an 8 seater cab easily through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of 8 seater vehicles are available for rent in Pune?',
        answer: 'We offer a range of 8 seater vehicles including Innova Crysta and similar SUVs known for comfort and space.',
    },
    {
        question: 'Can I rent an 8 seater cab for local Pune trips as well as outstation travel?',
        answer: 'Yes, 8 seater cabs are available for both local trips within Pune and outstation journeys.',
    },
    {
        question: 'Are the drivers experienced for driving 8 seater vehicles?',
        answer: 'Yes, our drivers are professional and experienced in handling larger vehicles to ensure your safety and comfort.',
    },
    {
        question: 'Can I book an 8 seater cab for hourly, daily, or multi-day rentals?',
        answer: 'Absolutely, we offer flexible hourly, daily, and multi-day rental packages for 8 seater cabs.',
    },
    {
        question: 'Are the 8 seater cabs sanitized and safe to travel?',
        answer: 'Yes, all our vehicles, including 8 seaters, are regularly sanitized and maintained with strict safety protocols.',
    },
    {
        question: 'Can I customize pickup and drop locations for the 8 seater cab rental?',
        answer: 'Yes, you can specify any pickup and drop-off points within Pune or for outstation trips.',
    },
    {
        question: 'What payment options are available for 8 seater cab rentals?',
        answer: 'We accept multiple payment methods including cash, credit/debit cards, and digital wallets.',
    },
    {
        question: 'Is 24x7 booking available for 8 seater cabs in Pune?',
        answer: 'Yes, you can book 8 seater cabs anytime with our 24x7 customer support.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Anil Kulkarni',
        feedback: 'The 8 seater cab I rented from Platinum24 Cabs was spacious and comfortable, perfect for our group outing.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Sneha More',
        feedback: 'Great experience renting an 8 seater cab for our family trip. The driver was courteous and the vehicle well-maintained.',
        rating: 5,
    },
];























































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];








const eightSeaterCabSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Affordable and reliable 8-Seater cab rental service in Pune offering tempo travellers, family cabs, outstation trips, airport transfers, and corporate travel solutions.",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "serviceType": [
    "8-Seater Cab Rental Pune",
    "Pune 8-Seater Taxi Hire",
    "8-Seater Car on Rent Pune",
    "Pune 8-Seater Cab with Driver",
    "8-Seater Tempo Traveller Pune",
    "Affordable 8-Seater Cab Pune",
    "8-Seater Taxi Booking Pune",
    "Pune 8-Seater Family Cab",
    "8-Seater Outstation Cab Pune",
    "8-Seater Cab Packages Pune",
    "Pune 8-Seater Airport Taxi",
    "8-Seater Group Travel Cab Pune",
    "Pune 8-Seater Cab Deals",
    "8-Seater Cab for Corporate Pune",
    "8-Seater Cab Rental Service Pune"
  ],
  "telephone": "+91-XXXXXXXXXX"
};







    return (
        <div>
<Helmet>
  <title>8-Seater Cab on Rent in Pune | Affordable Tempo Traveller & Family Cabs</title>
  <meta
    name="description"
    content="Affordable and reliable 8-Seater cab rental service in Pune offering tempo travellers, family cabs, outstation trips, airport transfers, and corporate travel solutions."
  />
  <meta
    name="keywords"
    content="8-Seater Cab Rental Pune, Pune 8-Seater Taxi Hire, 8-Seater Car on Rent Pune, Pune 8-Seater Cab with Driver, 8-Seater Tempo Traveller Pune, Affordable 8-Seater Cab Pune, 8-Seater Taxi Booking Pune, Pune 8-Seater Family Cab, 8-Seater Outstation Cab Pune, 8-Seater Cab Packages Pune, Pune 8-Seater Airport Taxi, 8-Seater Group Travel Cab Pune, Pune 8-Seater Cab Deals, 8-Seater Cab for Corporate Pune, 8-Seater Cab Rental Service Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(eightSeaterCabSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/61.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Eightseatercabonrent;